import React, { useState } from "react";
import "../styles/navbar.css";
import navLogo from "../asserts/nav-logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("health");

  const handleClick = (section) => {
    setActive(section);

    document.getElementById(section)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <div className="logo-icon">
          <img src={navLogo} alt="Gyde Logo" />
        </div>

        <h2>Gyde</h2>
      </div>

      {/* Hamburger */}

      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigation */}

      <div className={`nav-links ${menuOpen ? "show" : ""}`}>

        <button
          className={active === "technology" ? "active" : ""}
          onClick={() => handleClick("technology")}
        >
          Our Technology
        </button>

        <button
          className={active === "health" ? "active" : ""}
          onClick={() => handleClick("health")}
        >
          GydeHealth
        </button>

        <button>
          GydeSports
        </button>

        <button
          className={active === "about" ? "active" : ""}
          onClick={() => handleClick("about")}
        >
          About us
        </button>

      </div>
    </nav>
  );
};

export default Navbar;